import { useState } from 'react';

import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { PeriodDatePicker } from 'src/components/PeriodDatePicker';
import { useAuthContext } from 'src/context/AuthContextProvider';

interface FilterState {
  startDate: string | null;
  endDate: string | null;
  type: string;
  category: string;
  species: string;
}

const assembleiaTypes = [
  { value: 'AGE', label: 'Assembleia Extraordinária' },
  { value: 'AGO', label: 'Assembleia Ordinária' },
  { value: 'AGO/E', label: 'Assembleia Especial' },
];

export function TimelineFilters({
  filtersData,
  filters,
  setFilters,
}: {
  filtersData: {
    types: string[];
    categories: string[];
    species: string[];
    markets: string[];
  };
  filters: FilterState;
  setFilters: (filters: FilterState) => void;
}) {
  const { auth } = useAuthContext();
  const [documentType, setDocumentType] = useState<string>('All');
  const [type, setType] = useState<string>('All');
  const [species, setSpecies] = useState<string>('All');

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value);
    setFilters({
      ...filters,
      type: event.target.value === 'All' ? '' : event.target.value,
    });
  };

  const handleCategoryChange = (event: SelectChangeEvent) => {
    setDocumentType(event.target.value);
    setFilters({
      ...filters,
      category: event.target.value === 'All' ? '' : event.target.value,
    });
  };

  const handleSpeciesChange = (event: SelectChangeEvent) => {
    setSpecies(event.target.value);
    setFilters({
      ...filters,
      species: event.target.value === 'All' ? '' : event.target.value,
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} flexWrap="wrap" mt={2}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          alignItems: { sm: 'flex-start' },
          gap: 2,
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            width: { xs: '100%', lg: 'auto' },
          }}>
          {/* Filtro Categoria */}
          <FormControl
            variant="outlined"
            sx={{ minWidth: 180, width: { xs: '100%', md: 'auto' } }}
            size="small">
            <InputLabel id="document-type-label">Categoria</InputLabel>
            <Select
              labelId="document-type-label"
              value={documentType}
              onChange={handleCategoryChange}
              label="Categoria"
              disabled={
                !auth?.user?.subscription?.plan?.permissions?.linha_do_tempo
              }>
              <MenuItem value="All">Todas</MenuItem>
              {filtersData?.categories.map((category) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Filtro Tipo Assembleia */}
          <FormControl
            variant="outlined"
            sx={{ minWidth: 200, width: { xs: '100%', md: 'auto' } }}
            size="small">
            <InputLabel id="tipo-assembleia-label">Tipo Assembleia</InputLabel>
            <Select
              labelId="tipo-assembleia-label"
              value={type}
              onChange={handleTypeChange}
              label="Tipo Assembleia"
              disabled={
                !auth?.user?.subscription?.plan?.permissions?.linha_do_tempo
              }>
              <MenuItem value="All">Todos</MenuItem>
              {filtersData?.types.map((type) => (
                <MenuItem key={type} value={type}>
                  {assembleiaTypes.find((t) => t.value === type)?.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Filtro Especie Documento */}
          <FormControl
            variant="outlined"
            sx={{ minWidth: 180, width: { xs: '100%', md: 'auto' } }}
            size="small">
            <InputLabel id="especie-documento-label">
              Espécie Documento
            </InputLabel>
            <Select
              labelId="especie-documento-label"
              value={species}
              onChange={handleSpeciesChange}
              label="Especie Documento"
              disabled={
                !auth?.user?.subscription?.plan?.permissions?.linha_do_tempo
              }>
              <MenuItem value="All">Todas</MenuItem>
              {filtersData?.species.map((species) => (
                <MenuItem key={species} value={species}>
                  {species}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
          <PeriodDatePicker
            label="Data de Referência"
            filters={{
              dateRange: {
                start: filters.startDate,
                end: filters.endDate,
              },
            }}
            setFilters={(filters) =>
              setFilters({
                ...filters,
                startDate: filters.dateRange.start,
                endDate: filters.dateRange.end,
                category: '',
                species: '',
                type: '',
              })
            }
            disabled={
              !auth?.user?.subscription?.plan?.permissions?.linha_do_tempo
            }
          />
        </Box>
      </Box>
    </Box>
  );
}
